import React, { useState, useEffect } from "react";
import axios from "axios";
import { Plus, X } from "react-feather";
import { SERVER_URL } from "../../constants";

const CategoryManagement = () => {
  const [categoriesData, setCategoriesData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [editableCategory, setEditableCategory] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${SERVER_URL}/api/v1/category`);
        setCategoriesData(response.data.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const handleRowClick = (category) => {
    setSelectedCategory(category);
    setEditableCategory({ ...category });
  };

  const closeModal = () => {
    setSelectedCategory(null);
    setEditableCategory(null);
  };

  const handleCategoryChange = (e) => {
    const { name, value } = e.target;
    setEditableCategory((prev) => ({ ...prev, [name]: value }));
  };

  const handleCategoryImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", "unsigned_preset"); // Replace with your Cloudinary preset

      try {
        const response = await axios.post(
          "https://api.cloudinary.com/v1_1/dkzwhqhbr/image/upload",
          formData
        );
        setEditableCategory((prev) => ({ ...prev, imgUrl: response.data.secure_url }));
      } catch (error) {
        console.error("Error uploading category image:", error);
      }
    }
  };

  const handleSubCategoryImageChange = async (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", "unsigned_preset"); // Replace with your Cloudinary preset

      try {
        const response = await axios.post(
          "https://api.cloudinary.com/v1_1/dkzwhqhbr/image/upload",
          formData
        );
        const updatedSubcategories = [...editableCategory.subcategories];
        updatedSubcategories[index].imgUrl = response.data.secure_url;
        setEditableCategory((prev) => ({ ...prev, subcategories: updatedSubcategories }));
      } catch (error) {
        console.error("Error uploading subcategory image:", error);
      }
    }
  };

  const handleAddSubCategory = () => {
    setEditableCategory((prev) => ({
      ...prev,
      subcategories: [
        ...prev.subcategories,
        { name: "", description: ""},
      ],
    }));
  };

  const handleDeleteSubCategory = async (subCategoryId) => {
    console.log(subCategoryId)
    try {
      // Send delete request to the backend
      const res= axios.delete(`${SERVER_URL}/api/v1/subcategory/${subCategoryId}`);
     
      
        const updatedSubcategories = editableCategory.subcategories.filter(
          (sub) => sub._id !== subCategoryId
        );
    
        setEditableCategory((prev) => ({
          ...prev,
          subcategories: updatedSubcategories,
        }));

      
  
      // Update the local state after successful deletion
     
  
      console.log(`Subcategory with ID ${subCategoryId} deleted successfully.`);
    } catch (error) {
      console.error("Error deleting subcategory:", error);
    }
  };
  

  const handleDeleteCategory = async (categoryId) => {
    try {
      await axios.delete(`${SERVER_URL}/api/v1/category/${categoryId}`);
      setCategoriesData((prev) => prev.filter((category) => category._id !== categoryId));
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };
  const handleSubCategoryChange = (index, e) => {
    const { name, value } = e.target;
  
    // Create a copy of the current subcategories
    const updatedSubcategories = [...editableCategory.subcategories];
  
    // Update the specific subcategory at the given index
    updatedSubcategories[index] = { 
      ...updatedSubcategories[index], 
      [name]: value 
    };
  
    // Update the state with the modified subcategories
    setEditableCategory((prev) => ({
      ...prev,
      subcategories: updatedSubcategories,
    }));
  };
  

  const handleSaveChanges = async () => {
    try {
      // Update category
      await axios.put(`${SERVER_URL}/api/v1/category/${editableCategory._id}`, {
        name: editableCategory.name,
        description: editableCategory.description,
        imgUrl: editableCategory.imgUrl,
      });

      // Update subcategories
      for (const subCategory of editableCategory.subcategories) {
        if (subCategory._id) {
          await axios.put(`${SERVER_URL}/api/v1/subcategory/${subCategory._id}`, {
            name: subCategory.name,
            description: subCategory.description,
          });
        } else {
          await axios.post(`${SERVER_URL}/api/v1/subcategory`, {
            name: subCategory.name,
            description: subCategory.description,
            categoryId: editableCategory._id,
          });
        }
      }

      setCategoriesData((prev) =>
        prev.map((cat) =>
          cat._id === editableCategory._id ? { ...editableCategory } : cat
        )
      );

      closeModal();
    } catch (error) {
      console.error("Error saving changes:", error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6 lg:p-8">
      <div className="mx-auto max-w-7xl">
        <h2 className="mb-6 text-2xl font-bold text-gray-800 sm:text-3xl">
          Category Management
        </h2>
        
        {/* Table Container with horizontal scroll */}
        <div className="overflow-hidden rounded-lg bg-white shadow-md">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[800px] border-collapse">
              <thead>
                <tr className="bg-gray-100">
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Category Name</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Description</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Subcategories</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {categoriesData.map((category) => (
                  <tr key={category._id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-900">{category.name}</td>
                    <td className="px-4 py-3 text-sm text-gray-500">{category.description}</td>
                    <td className="px-4 py-3 text-sm text-gray-500">
                      {category.subcategories.map((sub) => sub.name).join(", ")}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      <button
                        onClick={() => handleRowClick(category)}
                        className="mr-3 text-blue-600 hover:text-blue-800"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDeleteCategory(category._id)}
                        className="text-red-600 hover:text-red-800"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
  
        {/* Modal */}
        {selectedCategory && (
          <div className="fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-50" aria-labelledby="modal-title" role="dialog">
            <div className="flex min-h-screen items-end justify-center px-4 pb-20 pt-4 text-center sm:block sm:p-0">
              <div className="relative inline-block transform overflow-hidden rounded-lg bg-white p-4 text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl sm:p-6 sm:align-middle">
                <button
                  onClick={closeModal}
                  className="absolute right-4 top-4 text-gray-400 hover:text-gray-500 focus:outline-none"
                >
                  <X size={24} />
                </button>
  
                <div className="sm:flex sm:items-start">
                  <div className="w-full">
                    <h3 className="mb-6 text-xl font-semibold text-gray-900">
                      Edit Category
                    </h3>
  
                    <div className="space-y-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Category Name
                        </label>
                        <input
                          type="text"
                          name="name"
                          value={editableCategory.name}
                          onChange={handleCategoryChange}
                          className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                        />
                      </div>
  
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Description
                        </label>
                        <textarea
                          name="description"
                          value={editableCategory.description}
                          onChange={handleCategoryChange}
                          rows={3}
                          className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                        />
                      </div>
  
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Category Image
                        </label>
                        <input
                          type="file"
                          onChange={handleCategoryImageChange}
                          className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:rounded-md file:border-0 file:bg-blue-50 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-blue-700 hover:file:bg-blue-100"
                        />
                      </div>
  
                      {/* Subcategories Section */}
                      <div className="mt-6">
                        <h4 className="mb-4 text-lg font-medium text-gray-900">
                          Subcategories
                        </h4>
                        <div className="space-y-6">
                          {editableCategory.subcategories.map((subCategory, index) => (
                            <div key={index} className="rounded-lg bg-gray-50 p-4">
                              <div className="space-y-4">
                                <div>
                                  <label className="block text-sm font-medium text-gray-700">
                                    Subcategory Name
                                  </label>
                                  <input
                                    type="text"
                                    name="name"
                                    value={subCategory.name}
                                    onChange={(e) => handleSubCategoryChange(index, e)}
                                    className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                                  />
                                </div>
  
                                <div>
                                  <label className="block text-sm font-medium text-gray-700">
                                    Description
                                  </label>
                                  <textarea
                                    name="description"
                                    value={subCategory.description}
                                    onChange={(e) => handleSubCategoryChange(index, e)}
                                    rows={2}
                                    className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                                  />
                                </div>
  
                                
                                <button
                                  onClick={() => handleDeleteSubCategory(subCategory._id)}
                                  className="mt-2 inline-flex items-center text-sm text-red-600 hover:text-red-800"
                                >
                                  <X size={16} className="mr-1" />
                                  Remove Subcategory
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>
  
                        <button
                          onClick={handleAddSubCategory}
                          className="mt-4 inline-flex items-center rounded-md bg-blue-50 px-4 py-2 text-sm font-medium text-blue-700 hover:bg-blue-100"
                        >
                          <Plus size={16} className="mr-2" />
                          Add Subcategory
                        </button>
                      </div>
                    </div>
  
                    <div className="mt-6 flex justify-end space-x-3">
                      <button
                        onClick={handleSaveChanges}
                        className="inline-flex items-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                      >
                        Save Changes
                      </button>
                      <button
                        onClick={closeModal}
                        className="inline-flex items-center rounded-md bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryManagement;
